import { axiosInstance } from './axios';

export interface MetricsData {
  total_applications: number;
  interviews: number;
  offers: number;
  response_rate: number;
  offer_success_rate: number;
  application_success_rate: number;
  engagement_rate: number;
  average_response_time: number;
  time_to_first_contact: number;
  target_positions: Array<{ position: string; count: number }>;
  monthly_applications: Array<{ month: string; count: number }>;
}

const defaultMetrics: MetricsData = {
  total_applications: 0,
  interviews: 0,
  offers: 0,
  response_rate: 0,
  offer_success_rate: 0,
  application_success_rate: 0,
  engagement_rate: 0,
  average_response_time: 0,
  time_to_first_contact: 0,
  target_positions: [],
  monthly_applications: []
};

export interface IndustryMetric {
  industry: string;
  percentage: number;
}

export interface MetricsResponse {
  data: MetricsData;
  status: number;
  message?: string;
}

const metricsApi = {
  /**
   * Get all metrics for the current user
   */
  getMetrics: async (): Promise<MetricsData> => {
    try {
      const { data } = await axiosInstance.get<MetricsData>('/metrics');
      // The API returns the metrics directly, not wrapped in a data property
      return {
        total_applications: data.total_applications,
        interviews: data.interviews,
        offers: data.offers,
        response_rate: data.response_rate,
        offer_success_rate: data.offer_success_rate,
        application_success_rate: data.application_success_rate,
        engagement_rate: data.engagement_rate,
        average_response_time: data.average_response_time,
        time_to_first_contact: data.time_to_first_contact,
        target_positions: data.target_positions || [],
        monthly_applications: data.monthly_applications || []
      };
    } catch (error) {
      console.error('Error fetching metrics:', error);
      return defaultMetrics;
    }
  },

  /**
   * Get metrics for a specific date range
   */
  getMetricsByDateRange: async (startDate: string, endDate: string): Promise<MetricsData> => {
    try {
      const { data } = await axiosInstance.get<MetricsData>('/metrics', {
        params: { start_date: startDate, end_date: endDate }
      });
      return data || defaultMetrics;
    } catch (error) {
      console.error('Error fetching metrics by date range:', error);
      return defaultMetrics;
    }
  },

  /**
   * Refresh/recalculate metrics
   */
  refreshMetrics: async (): Promise<MetricsData> => {
    try {
      const { data } = await axiosInstance.post<MetricsData>('/metrics/refresh');
      return data || defaultMetrics;
    } catch (error) {
      console.error('Error refreshing metrics:', error);
      return defaultMetrics;
    }
  }
};

export default metricsApi; 